/* eslint-disable no-unused-vars */
import { apolloClient } from "@/setup/apollo-setup";

import {
    GET_STUDENTENROLLDETAIL_BYID,
    GET_STUDENTENROLLDETAIL_BYID_FOR_LEARNING,
    GET_STUDENTENROLLDETAIL_LIST_BYSTUDENTENROLLID,
    GET_STUDENT_IN_CLASS_SECTION_BY_CODE_OR_NAME,
    GET_TEACHERS_IN_STUDENT_ENROLL_BY_CODE_OR_NAME_CURRENT_USER,
    GET_STUDENT_ENROLL_DETAILS_BY_CURRENT_USER,
    GET_STUDENT_ENROLL_DETAILS_BY_CURRENT_USER_WHILE_EXAM,
} from '@/queries/modules/student-enroll/student-enroll-detail.js';
import {getField, updateField} from "vuex-map-fields";

const state = {
  processing: false,
  error: null,
  success: null,};

const getters = {
  getField
};

const mutations = {
  updateField,
  clearError: (state) => {
    state.error = null;
  },
  setError: (state, payload) => {
    state.error = payload;
    state.success = null;
    state.processing = false;
  },
  setSuccess: (state, payload) => {
    state.error = null;
    state.success = payload;
    state.processing = false;
  },
  setProcessing: (state, payload) => {
    state.processing = payload;
  },
};

const actions = {

  async getStudentEnrollDetailById({commit}, payload) {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_STUDENTENROLLDETAIL_BYID,
          variables: payload,
          fetchPolicy: 'network-only',
          context: { clientName: 'Prisma2' }
        })
      const {data} = await result;

      commit('setProcessing', false);
      return data.getStudentEnrollDetail;

    } catch (e) {
      commit('setError', e);
      return null;
    }
  },

  async getStudentEnrollDetailByIdForLearning({commit}, payload) {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_STUDENTENROLLDETAIL_BYID_FOR_LEARNING,
          variables: payload,
          fetchPolicy: 'network-only',
          context: { clientName: 'Prisma2' }
        })
      const {data} = await result;

      commit('setProcessing', false);
      return data.getStudentEnrollDetail;

    } catch (e) {
      commit('setError', e);
      return null;
    }
  },

  async getStudentEnrollDetailListByStudentEnrollId({ commit }, payload) {
    // commit('setProcessing', true);
    // console.log("id", payload)
    try {
      const result = await apolloClient
      .query({
        query: GET_STUDENTENROLLDETAIL_LIST_BYSTUDENTENROLLID,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      })
      //studentEnrollDetailFilterInput
      const { data } = await result;

      return { status: { success: true, error: false, message: "" }, data: [ ...data.getStudentEnrollDetailsByStudentEnrollId ] };

    } catch (e) {
      // console.log(e);
      // commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }};
    }
  },

  async getStudentsInClassSectionByCodeOrName({ commit }, payload) {
    // commit('setProcessing', true);
    // console.log("id", payload)
    try {
      const result = await apolloClient
      .query({
        query: GET_STUDENT_IN_CLASS_SECTION_BY_CODE_OR_NAME,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })
      const { data } = await result;

      return data.getStudentsInClassSectionByCodeOrName;

    } catch (e) {
      // console.log(e);
      // commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }};
    }
  },

  async getTeachersInStudentEnrollByCodeOrNameCurrentUser({ commit }, payload) {
    // commit('setProcessing', true);
    // console.log("id", payload)
    try {
      const result = await apolloClient
      .query({
        query: GET_TEACHERS_IN_STUDENT_ENROLL_BY_CODE_OR_NAME_CURRENT_USER,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })
      const { data } = await result;

      return data.getTeachersInStudentEnrollByCodeOrNameCurrentUser;

    } catch (e) {
      // console.log(e);
      // commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }};
    }
  },

  async getStudentEnrollDetailsByCurrentUser({commit}) {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_STUDENT_ENROLL_DETAILS_BY_CURRENT_USER,
          fetchPolicy: 'network-only',
          context: { clientName: 'Prisma2' }
        })
      const {data} = await result;

      commit('setProcessing', false);
      // commit('setStudentEnrolls', data.getStudentEnrollsByCurrentUser);
      return data.getStudentEnrollDetailsByCurrentUser;

    } catch (e) {
      commit('setError', e);
      return null;
    }
  },

  async getStudentEnrollDetailsByCurrentUserWhileExam({commit}) {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_STUDENT_ENROLL_DETAILS_BY_CURRENT_USER_WHILE_EXAM,
          fetchPolicy: 'network-only',
          context: { clientName: 'Prisma2' }
        })
      const {data} = await result;

      commit('setProcessing', false);
      // commit('setStudentEnrolls', data.getStudentEnrollsByCurrentUser);
      return data.getStudentEnrollDetailsByCurrentUser;

    } catch (e) {
      commit('setError', e);
      return null;
    }
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
